import React from 'react';

import classNames from 'classnames';
import LockIcon from 'icons/ic-lock-10.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import Tooltip from 'components/application/Tooltip';

export default function EnforceFormCard({
  formValues,
  isEnabled,
  isUpgradeRequired,
  onInputChange,
  onSubmit,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.singleSignOn.components.EnforceFormCard',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className='section tw-relative tw-border-grey-100 tw-bg-white tw-p-10'>
      {isUpgradeRequired && (
        <div className='tooltip-parent tw-absolute -tw-top-3 tw-left-2 tw-m-0 tw-flex tw-items-center tw-rounded-s-sm tw-border-0 tw-bg-mutedBlue-050 tw-px-2 tw-py-[6px] tw-text-mutedBlue-700'>
          <LockIcon
            className='tw-mr-2 [&_path]:tw-fill-mutedBlue-700'
            height={10}
            width={8}
          />
          <span className='tw-text-xs tw-font-semibold tw-tracking-wide'>
            {i18nT('upgradeRequired.title')}
          </span>
          <Tooltip
            placement='top'
            tooltip={i18nT('upgradeRequired.tooltip')}
            trigger='hover'
          />
        </div>
      )}
      <h3 className='tw-mb-2 tw-mt-0 tw-text-l tw-font-semibold tw-tracking-auto tw-text-grey-900'>
        {i18nT('title')}
      </h3>
      <p className='tw-m-0 tw-mb-8'>
        {i18nT('descriptions.enforce')}{' '}
        {isUpgradeRequired ?
          i18nT('upgradeRequired.description')
        : i18nT('descriptions.doNotRecommend')}
      </p>
      <div className='form-group tw-m-0'>
        <label
          className='hhq-checkbox__label tooltip-parent'
          htmlFor='enforced'
        >
          <input
            checked={formValues.enforced}
            className='hhq-checkbox__input'
            disabled={isUpgradeRequired || !isEnabled}
            id='enforced'
            name='enforced'
            onChange={onInputChange}
            type='checkbox'
            value='enforced'
          />
          <span
            className={classNames(
              'hhq-checkbox__toggle tw-cursor-pointer tw-border-2 tw-font-bold tw-text-white',
              formValues.enforced ?
                'tw-border-blue-400 tw-bg-blue-400 hover:tw-border-blue-500 hover:tw-bg-blue-500'
              : 'tw-border-grey-300 tw-bg-white hover:tw-border-blue-300 hover:tw-bg-grey-025',
            )}
          />
          {!isEnabled && (
            <div className='tw-absolute tw-left-0 tw-top-0 tw-h-5.5 tw-w-5.5'>
              <Tooltip
                placement='top'
                tooltip={i18nT('form.enforced.tooltip')}
                trigger='hover'
              />
            </div>
          )}
          <span className='tw-ml-3 tw-font-normal tw-tracking-auto'>
            {i18nT('form.enforced.label')}
          </span>
        </label>
      </div>
      <FilledButton
        className='tw-mt-10'
        color='blue'
        disabled={isUpgradeRequired || !isEnabled}
        onClick={onSubmit}
      >
        {i18nTShared('saveChanges')}
      </FilledButton>
    </div>
  );
}

EnforceFormCard.propTypes = {
  formValues: PropTypes.object.isRequired,
  isUpgradeRequired: PropTypes.bool.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
